import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    NotificationImg,
    HtmlWrapper,
    HtmlOverlayHrefMask,
    HtmlOverlayMask,
    HtmlIframeWrapper,
    VideoWrapper,
    VideoIframeWrapper,
} from './Notification.style';
import { NotificationMediaState } from './NotificationMedia.state';
import { PromoNotificationsModelForViewType } from 'src/domains/layouts/state/notificationsState/NotificationsState';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

interface PropsType {
    notification: PromoNotificationsModelForViewType;
}

export const NotificationMedia = observer('NotificationMedia', ({ notification }: PropsType) => {
    const common = useCommon();

    const breakpointsState = BreakpointsState.get(common);
    const isMobile = breakpointsState.desktop.isBiggerOrEq === false;
    const starRouter = StarRouter.get(common);
    const [state] = React.useState(
        () => new NotificationMediaState(starRouter, notification, AppSportsBookState.get(common).models, common)
    );

    const { cta_url, img_url, html_url, video_url, title, media_type, action_template } = notification;
    const video_url_for_view = video_url ?? '';
    const img_url_for_view = img_url ?? '';
    const html_url_or_view = html_url ?? '';

    const handleMatchUrl = (): void => {
        if (cta_url === null || cta_url === undefined) return;
        if (cta_url.includes('account=') && isMobile) {
            starRouter.redirectToHomepage();
        }
        setTimeout(() => {
            starRouter.handleUrlRedirection(cta_url);
        }, 0);
    };

    if (media_type === 'video' && video_url_for_view !== '') {
        return (
            <VideoWrapper>
                <VideoIframeWrapper
                    title={title}
                    src={video_url_for_view}
                    frameBorder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                    width='100%'
                    height='100%'
                />
            </VideoWrapper>
        );
    }

    if (media_type === 'static' && img_url_for_view !== '') {
        if (action_template === 'direct-link') {
            return (
                <div onClick={handleMatchUrl}>
                    <NotificationImg
                        alt=''
                        imgBase={{
                            src: img_url_for_view,
                            optimizeOptions: {
                                width: 520,
                                quality: 75,
                            },
                        }}
                    />
                </div>
            );
        }

        return (
            <div onClick={state.handleOnClick}>
                <NotificationImg
                    alt=''
                    imgBase={{
                        src: img_url_for_view,
                        optimizeOptions: {
                            width: 520,
                            quality: 75,
                        },
                    }}
                />
            </div>
        );
    }

    if (media_type === 'html' && html_url_or_view !== '') {
        if (action_template === 'direct-link') {
            return (
                <HtmlWrapper>
                    <HtmlIframeWrapper
                        title={title}
                        src={html_url_or_view}
                        frameBorder='0'
                        width='100%'
                        height='100%'
                    />
                    <HtmlOverlayHrefMask
                        target='_blank'
                        href={cta_url ?? ''}
                    />
                </HtmlWrapper>
            );
        }

        return (
            <HtmlWrapper onClick={state.handleOnClick}>
                <HtmlIframeWrapper
                    title={title}
                    src={html_url_or_view}
                    frameBorder='0'
                    width='100%'
                    height='100%'
                />
                <HtmlOverlayMask />
            </HtmlWrapper>
        );
    }

    return null;
});
